import { render, staticRenderFns } from "./footdiv.vue?vue&type=template&id=b88ecd58&scoped=true&"
import script from "./footdiv.vue?vue&type=script&lang=js&"
export * from "./footdiv.vue?vue&type=script&lang=js&"
import style0 from "./footdiv.vue?vue&type=style&index=0&id=b88ecd58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../55/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88ecd58",
  null
  
)

export default component.exports